const initialState = {
  open: false,
};

const adilloMsg = (state = initialState, action) => {
  switch (action.type) {
    case 'TOGGLE_ADILLO_MSG':
      return {
        ...state,
        open: action.data,
      };
    case 'LOGOUT_SUCCESS':
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default adilloMsg;
